import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import MenuIcon from '@mui/icons-material/Menu';
import { IconButton, Typography } from "@mui/material";
import { BackIconStyle, LabelStyle } from './styled';

interface Props {
  handleNavIcon: (level?: number) => void,
  navIcon?: "menu" | "back" | "breadcrumbs",
  navIconLabel?: string | string[],
  dataAutomation?: { backButton?: string }
}

export const Menu = ({
  handleNavIcon,
  navIcon,
  navIconLabel,
  dataAutomation
}: Props) => {
  return (
    <IconButton
      size="large"
      edge="start"
      data-automation="HamburgerIcon"
      color="inherit"
      aria-label="menu"
      sx={{ mr: 2, position: 'absolute', left: '10px' }}
      onClick={() => handleNavIcon()}
    >
      {navIcon === "menu" ? <MenuIcon /> :
        <Typography data-automation={dataAutomation?.backButton || 'back-btn'} sx={LabelStyle}>
          <ArrowBackIosIcon sx={BackIconStyle} />
          {navIconLabel}
        </Typography>
      }
    </IconButton>
  );
}